const TRIGGER_ATTRIBUTE = 'data-text-block-drawer-trigger';
const MOVED_ATTRIBUTE = 'data-text-block-drawer-moved';
const MARKER_TEXT = '(?)';
const INLINE_TEXT_CLASS = 'text-block__drawer-inline-text';
const INIT_FLAG = '__textBlockDrawerInitialized';

if (window[INIT_FLAG]) {
  // Prevent duplicate listeners/observers when this asset is re-evaluated.
} else {
  window[INIT_FLAG] = true;

const insertAtMarker = (trigger, textBlock) => {
  const walker = document.createTreeWalker(textBlock, NodeFilter.SHOW_TEXT);

  while (walker.nextNode()) {
    const node = walker.currentNode;
    if (!node || !node.nodeValue) continue;

    const markerIndex = node.nodeValue.indexOf(MARKER_TEXT);
    if (markerIndex === -1) continue;

    const parent = node.parentNode;
    if (!parent) return true;

    const beforeText = node.nodeValue.slice(0, markerIndex);
    const afterText = node.nodeValue.slice(markerIndex + MARKER_TEXT.length);

    if (beforeText) parent.insertBefore(document.createTextNode(beforeText), node);
    parent.insertBefore(trigger, node);
    if (afterText) parent.insertBefore(document.createTextNode(afterText), node);
    parent.removeChild(node);

    trigger.hidden = false;
    trigger.setAttribute(MOVED_ATTRIBUTE, 'true');
    return true;
  }

  return false;
};

const moveInlineTrigger = (trigger) => {
  if (!(trigger instanceof HTMLElement)) return;
  if (trigger.hasAttribute(MOVED_ATTRIBUTE)) return;

  const previousElement = trigger.previousElementSibling;
  if (!(previousElement instanceof HTMLElement)) return;

  const textBlock = previousElement.classList.contains('text-block-truncate')
    ? previousElement.querySelector('.text-block')
    : previousElement;
  if (!(textBlock instanceof HTMLElement)) return;

  if (insertAtMarker(trigger, textBlock)) return;

  const target =
    textBlock.querySelector('li:last-of-type') ||
    textBlock.querySelector('p:last-of-type') ||
    textBlock.querySelector(':scope > *:last-child');

  if (!(target instanceof HTMLElement)) {
    const wrapper = document.createElement('span');
    wrapper.classList.add(INLINE_TEXT_CLASS);
    while (textBlock.firstChild) {
      wrapper.appendChild(textBlock.firstChild);
    }
    textBlock.appendChild(wrapper);
    wrapper.appendChild(trigger);
    trigger.hidden = false;
    trigger.setAttribute(MOVED_ATTRIBUTE, 'true');
    return;
  }

  target.appendChild(trigger);
  trigger.hidden = false;
  trigger.setAttribute(MOVED_ATTRIBUTE, 'true');
};

const initInlineTriggers = () => {
  document.querySelectorAll(`[${TRIGGER_ATTRIBUTE}]`).forEach(moveInlineTrigger);
};

let rafId;
const scheduleInlineTriggerInit = () => {
  if (rafId) cancelAnimationFrame(rafId);
  rafId = requestAnimationFrame(() => {
    initInlineTriggers();
    // Run a second pass for async morphs that complete right after first paint.
    requestAnimationFrame(initInlineTriggers);
    rafId = undefined;
  });
};

const handleClick = (event) => {
  const trigger = event.target.closest(`[${TRIGGER_ATTRIBUTE}]`);
  if (!trigger) return;

  event.preventDefault();

  const drawerId = trigger.getAttribute(TRIGGER_ATTRIBUTE);
  if (!drawerId) return;

  const drawerDialog = document.getElementById(`Details-drawer-${drawerId}`);
  const drawer = drawerDialog?.closest('generic-drawer');

  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
    return;
  }

  if (drawerDialog instanceof HTMLDialogElement) {
    drawerDialog.showModal();
  }
};

document.addEventListener('click', handleClick);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInlineTriggers);
} else {
  initInlineTriggers();
}

document.addEventListener('shopify:section:load', initInlineTriggers);
document.addEventListener('variant:update', scheduleInlineTriggerInit);
document.addEventListener('shopify:section:reorder', scheduleInlineTriggerInit);
document.addEventListener('shopify:section:select', scheduleInlineTriggerInit);
document.addEventListener('shopify:section:deselect', scheduleInlineTriggerInit);

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (!(mutation.target instanceof Element)) continue;

    if (
      mutation.target.matches?.(`[${TRIGGER_ATTRIBUTE}]`) ||
      mutation.target.querySelector?.(`[${TRIGGER_ATTRIBUTE}]`) ||
      Array.from(mutation.addedNodes).some(
        (node) =>
          node instanceof Element &&
          (node.matches?.(`[${TRIGGER_ATTRIBUTE}]`) || node.querySelector?.(`[${TRIGGER_ATTRIBUTE}]`))
      )
    ) {
      scheduleInlineTriggerInit();
      return;
    }
  }
});

if (document.body) {
  observer.observe(document.body, { childList: true, subtree: true });
} else {
  document.addEventListener(
    'DOMContentLoaded',
    () => observer.observe(document.body, { childList: true, subtree: true }),
    { once: true }
  );
}
}
